import React, { useContext } from 'react';
import styled from 'styled-components';

import ContentTabsItem from './content-tabs-item';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  border-bottom: 1px solid #999999;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: 50px;
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    @media (max-width: 540px) {
      display: none;
    }
  }
`;

const ContentTabs = ({ categories, active, toggleCategory }) => {
  const { language } = useContext(LanguageContext);
  let verTodos = ''
  let aprendaMais = ''
  let videos = ''
  switch (language) {
    case 'pt-br':
      verTodos = 'Ver todos';
      aprendaMais = 'Aprenda mais';
      videos = 'Vídeos';
      break;
    case 'en-us':
      verTodos = 'View all';
      aprendaMais = 'Learn more';
      videos = 'Videos';
      break;
    case 'es-es':
      verTodos = 'Ver todo';
      aprendaMais = 'Aprende más';
      videos = 'Videos';
      break;
    default:
  }
  return (
    <Container>
      <ul>
        <ContentTabsItem toggleCategory={ toggleCategory } active={ active } text={ verTodos } />
        <ContentTabsItem toggleCategory={ toggleCategory } active={ active } text="Blog" />
        <ContentTabsItem toggleCategory={ toggleCategory } active={ active } text={ videos } />
        <ContentTabsItem toggleCategory={ toggleCategory } active={ active } text={ aprendaMais } />
      </ul>
    </Container>
  );
}

export default ContentTabs;
